 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXT02_TITLE from '@/components/Text/02_title'
 import TEXT02A_COPYRIGHT from '@/components/Text/02a_copyright'
 import TEXT05_ACKNOWLEDGMENTS from '@/components/Text/05_acknowledgments'
 import TEXT07_CHAPTER011 from '@/components/Text/07_chapter011'
 import TEXT09_CHAPTER021 from '@/components/Text/09_chapter021'
 import TEXT11_CHAPTER031 from '@/components/Text/11_chapter031'
 import TEXT13_CHAPTER041 from '@/components/Text/13_chapter041'
 import TEXT15_CHAPTER051 from '@/components/Text/15_chapter051'
 import TEXT17_CHAPTER061 from '@/components/Text/17_chapter061'
 import TEXT19_CHAPTER071 from '@/components/Text/19_chapter071'
 import TEXT21_CHAPTER081 from '@/components/Text/21_chapter081'
 import TEXT23_CHAPTER091 from '@/components/Text/23_chapter091'
 import TEXT25_CHAPTER101 from '@/components/Text/25_chapter101'
 import TEXT27_CHAPTER111 from '@/components/Text/27_chapter111'
 import TEXT29_CHAPTER121 from '@/components/Text/29_chapter121'
 import TEXT31_CHAPTER131 from '@/components/Text/31_chapter131'
 import TEXT33_CHAPTER141 from '@/components/Text/33_chapter141'
 import TEXT35_CHAPTER151 from '@/components/Text/35_chapter151'
 import TEXT37_CHAPTER161 from '@/components/Text/37_chapter161'
 import TEXT39_CHAPTER171 from '@/components/Text/39_chapter171'
 import TEXT41_CHAPTER181 from '@/components/Text/41_chapter181'
 import LOVE_2 from '@/components/love_2'
 import TEXTMOREFROM from '@/components/Text/morefrom'
 import TEXTCONNECT from '@/components/Text/connect'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/02_title",
 			"name" : "Text/02_title",
 			"component" : TEXT02_TITLE
 		},
 		{
 			"path" : "/Text/02a_copyright",
 			"name" : "Text/02a_copyright",
 			"component" : TEXT02A_COPYRIGHT
 		},
 		{
 			"path" : "/Text/05_acknowledgments",
 			"name" : "Text/05_acknowledgments",
 			"component" : TEXT05_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/Text/07_chapter011",
 			"name" : "Text/07_chapter011",
 			"component" : TEXT07_CHAPTER011
 		},
 		{
 			"path" : "/Text/09_chapter021",
 			"name" : "Text/09_chapter021",
 			"component" : TEXT09_CHAPTER021
 		},
 		{
 			"path" : "/Text/11_chapter031",
 			"name" : "Text/11_chapter031",
 			"component" : TEXT11_CHAPTER031
 		},
 		{
 			"path" : "/Text/13_chapter041",
 			"name" : "Text/13_chapter041",
 			"component" : TEXT13_CHAPTER041
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js